import { z } from "zod";
import dayjs from "dayjs";

export const dateSchema = z.preprocess(date => {
  if (typeof date === "string") {
    return dayjs(date).toDate();
  }
  if (typeof date !== "number") {
    return null;
  }
  const unixDate = dayjs.unix(date);
  if (!unixDate.isValid()) {
    return null;
  }
  return unixDate.toDate();
}, z.date().nullable().default(null));
